import { createContext, useContext, useEffect, useState } from "react";
import { fetchSiteConfig } from "../lib/api";

const SiteContext = createContext({
  whatsapp_number: "+447000000000",
  support_email: "support@sterlingbio.example",
  company_name: "Sterling Bio Ltd",
  country: "United Kingdom",
});

export const SiteProvider = ({ children }) => {
  const [config, setConfig] = useState({
    whatsapp_number: "+447000000000",
    support_email: "support@sterlingbio.example",
    company_name: "Sterling Bio Ltd",
    country: "United Kingdom",
  });

  useEffect(() => {
    fetchSiteConfig()
      .then((c) => setConfig(c))
      .catch(() => {});
  }, []);

  return <SiteContext.Provider value={config}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);

export const buildWhatsAppUrl = (number, message) => {
  const cleaned = String(number || "").replace(/[^\d]/g, "");
  return `https://wa.me/${cleaned}?text=${encodeURIComponent(message)}`;
};
